var map = {
	"./smm-1.png": "./src/img/works/smm/smm-1.png",
	"./smm-2.png": "./src/img/works/smm/smm-2.png",
	"./smm-3.png": "./src/img/works/smm/smm-3.png",
	"./smm-4.png": "./src/img/works/smm/smm-4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/works/smm sync \\.(png%7Cjpe?g%7Csvg)$";